import { ComponentProps } from 'react';
import { Row } from '@ahmdigital/ui';
import styled from 'styled-components';

type AlignableRowProps = ComponentProps<typeof Row> & {
  centered?: boolean;
};

export const AlignableRow = styled(Row)<AlignableRowProps>`
  justify-content: ${({ centered }) => (centered ? 'center' : 'flex-start')};
`;
